export function getPropertyInitials(propertyName: string): string {
  return propertyName
    .trim()
    .split(' ')
    .filter((w: string) => w.length > 0)
    .map((w: string) => w[0].toUpperCase())
    .join('');
}
